/* window.MI_CONFIG - reservado para configuración futura de la integración de checkout (no usado actualmente). */
/* window.CHECKOUT_APP - reservado para la referencia global de la app de checkout/COD (Releasit gestiona su propio runtime). */
(function(){
  "use strict";

  function initGallery(root){
    var track = root.querySelector(".mbp-gallery-track");
    var dotsWrap = root.querySelector(".mbp-dots");
    if(!track || !dotsWrap) return;
    var slides = track.querySelectorAll(".mbp-slide");
    if(!slides.length) return;

    slides.forEach(function(_, i){
      var d = document.createElement("span");
      if(i === 0) d.className = "mbp-dot-active";
      dotsWrap.appendChild(d);
    });
    var dots = dotsWrap.querySelectorAll("span");

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function(d, i){ d.className = i === idx ? "mbp-dot-active" : ""; });
        }
      });
    }, { root: track, threshold: 0.6 });

    slides.forEach(function(s){ io.observe(s); });
  }

  function initCountdown(root){
    var el = root.querySelector(".mbp-countdown");
    if(!el) return;
    var hours = parseFloat(el.getAttribute("data-hours")) || 3;
    var key = "mbp_countdown_end_" + (root.id || "default");
    var end = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if(!end || isNaN(end) || end < now){
      end = now + hours * 3600 * 1000;
      localStorage.setItem(key, String(end));
    }
    var hEl = el.querySelector(".mbp-cd-h");
    var mEl = el.querySelector(".mbp-cd-m");
    var sEl = el.querySelector(".mbp-cd-s");

    function tick(){
      var diff = end - Date.now();
      if(diff <= 0){
        end = Date.now() + hours * 3600 * 1000;
        localStorage.setItem(key, String(end));
        diff = end - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if(hEl) hEl.textContent = String(h).padStart(2, "0");
      if(mEl) mEl.textContent = String(m).padStart(2, "0");
      if(sEl) sEl.textContent = String(s).padStart(2, "0");
    }
    tick();
    setInterval(tick, 1000);
  }

  function initCarousel(root){
    var wrap = root.querySelector("[data-mbp-carousel]");
    if(!wrap) return;
    var track = wrap.querySelector(".mbp-carousel-track");
    var slides = wrap.querySelectorAll(".mbp-carousel-slide");
    if(!track || slides.length < 2) return;
    var idx = 0, timer;

    function go(i){
      idx = (i + slides.length) % slides.length;
      track.style.transform = "translateX(-" + (idx * 100) + "%)";
    }
    function restart(){
      clearInterval(timer);
      timer = setInterval(function(){ go(idx + 1); }, 4500);
    }
    var prev = wrap.querySelector(".mbp-carousel-prev");
    var next = wrap.querySelector(".mbp-carousel-next");
    if(prev) prev.addEventListener("click", function(){ go(idx - 1); restart(); });
    if(next) next.addEventListener("click", function(){ go(idx + 1); restart(); });

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ restart(); } else { clearInterval(timer); }
      });
    }, { threshold: 0.3 });
    io.observe(wrap);
  }

  function init(){
    document.querySelectorAll(".mbp-section").forEach(function(root){
      initGallery(root);
      initCountdown(root);
      initCarousel(root);
    });
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
